import { PageCriteriaDTO } from '@dto/PageCriteriaDTO';
import { PrescriptionRefillStatus } from '@enum/prescription/PrescriptionRefillStatus';

export class PrescriptionRefillPageCriteriaDTO extends PageCriteriaDTO {
  public status: PrescriptionRefillStatus;
}
